import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, KiloClassCoachRoleAutoComplete } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteClassCoachRolesProps {
  search: string;
}

function useAutoCompleteClassCoachRoles({
  search,
}: IUseAutoCompleteClassCoachRolesProps): UseQueryResult<{ data: Array<KiloClassCoachRoleAutoComplete> }> {
  const params: UrlParams = {};
  if (search) {
    params.search = search;
  }

  return useQuery(['class-coach-roles-autocomplete', search], () =>
    client.get(`kilo-class-coach-roles/auto-complete/?${encodeUrlParams(params)}`),
  );
}

export default useAutoCompleteClassCoachRoles;
